module.exports = __webpack_public_path__ + "static/media/ai&ml.f464114b.svg";